﻿export interface StationFile {
    Guid: string;
    StationId: string;
    Category: string;
    Name: string;
    MimeType: string;
    Size: number;
    DateAdded: number;
    LastModified: number;
    Link: string;
}

export interface StationFilesList {
    Regular: StationFile[];
    Special: StationFile[];
}

var BASE_URL = '/api/StationFiles';

export function getForecastPDFs(callback: (err: any, data: StationFilesList) => any): void {
    $.ajax(BASE_URL + '/ListForecastPDFs', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: StationFilesList, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(errorThrown, null);
        }
    });
}